import React from "react";
import { Button } from "react-bootstrap";
import {
  IoIosArrowDown,
  IoIosArrowForward,
  IoIosCheckmarkCircleOutline,
} from "react-icons/io";
import moment from "moment/moment";
import { useCallback, useEffect, useState } from "react";
import apiPath from "../../Utils/apiPath";
import { apiGet } from "../../Utils/apiFetch";
import { debounce, isEmpty, startCase } from "lodash";
import InternalLoader from "../../component/InternalLoader";
import GameRecordFilter from "./GameRecordFilter";
import { formatWithCommas, toFixedWithoutRounding } from "../../Utils/Toast";
import { useNavigate } from "react-router-dom";
const SpinReport = () => {
  const [data, setData] = useState([]);
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const getData = async () => {
    setLoader(true)
    const { status, data } = await apiGet(apiPath.spinReport, {
      page: 1,
      limit: 100,
    });
    if (status == 200) {
      if (data?.success) {
        setData(data?.results);
      }
    }
    setLoader(false);
  };
  useEffect(() => {
    getData();
  }, []);
  return (
    <div
      id="mc-animate-container"
      className="v-base v-detail-base fade-enter-done"
    >
      <div className="mc-transaction-record-root mtrr-container">
        <div className="mc-header-wrap">
          <div
            id="mc-header"
            className="mc-navbar-blue mc-record mc-default-header am-navbar am-navbar-light"
          >
            <div
              onClick={() => navigate(-1)}
              className="am-navbar-left"
              role="button"
            >
              <span className="am-navbar-left-content">
                <span className="return_icon">
                  <svg
                    style={{ color: "black" }}
                    className="am-icon am-icon-left am-icon-lg"
                  >
                    <use xlinkHref="#left" />
                  </svg>
                </span>
              </span>
            </div>
            <div className="am-navbar-title">Spin Report</div>
            <div className="am-navbar-right" />
          </div>
          <div className="am-whitespace am-whitespace-sm mc-whitespace" />
        </div>

        <div className="mc-trans-record-container name-filter">
          <div className="records-list-root">
            <ul
              className="scroll-inner-container"
              style={{ marginTop: "10px", paddingBottom: "0" }}
            >
              {data?.data?.length > 0 ? (
                data?.data?.map((res) => {
                  return (
                    <li>
                      <div className="rr-container">
                        <div
                          style={{ background: "#f1efef" }}
                          className="tr-item-content"
                        >
                          <div className="tr-item-detail">
                            <div className="tr-item-content-item">
                              <div className="tic-code">
                                Spin Count: {res?.spin}
                              </div>
                            </div>
                          </div>
                          <div className="tr-item-content-item tic-footer">
                            <div>
                              <span className="tic-footer-title number-mc">
                                P/L
                              </span>
                              <span className="tic-footer-amount number-mc">
                                {res.result}
                              </span>
                            </div>
                            <div>
                              <span className="tic-footer-title number-mc">
                                Settle date
                              </span>
                              <span className={`tic-footer-amount number-mc`}>
                                {moment(res?.createdAt).format(
                                  "DD-MM-YYYY HH:MM:SS",
                                )}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>
                  );
                })
              ) : (
                <div
                  className="nodata-container"
                  style={{ height: "607.609px" }}
                >
                  <svg className="am-icon am-icon-nodata_f4c19c2d am-icon-md nodata-icon">
                    <use xlinkHref="#nodata_f4c19c2d" />
                  </svg>
                  <p className>No data</p>
                </div>
              )}

            </ul>
          </div>
        </div>
      </div>{" "}

      {loader && <InternalLoader />}
    </div>
  );
};

export default SpinReport;
